import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router, UrlSegment } from '@angular/router';
import { Subscription } from 'rxjs';
import { DeviceService } from 'src/app/services/device.service';
import { Error429Service } from 'src/app/services/error429.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from "./../../../../environments/environment";

interface Clientes{
  value: number;
  name: string;
}
@Component({
  selector: 'app-editar-cerveza',
  templateUrl: './editar-cerveza.component.html',
  styleUrls: ['./editar-cerveza.component.css']
})
export class EditarCervezaComponent {

  cervezaCreada: boolean = false;
  waitAfterSave: boolean = false;
  cervezaId: any;
  beerData: any = [];
  beerImg: any;
  beerDataImgPath: string = "";

  //IMAGEN
  formData : FormData = new FormData();
  file: File | undefined;
  reader = new FileReader();
  imageUrl: string | ArrayBuffer | null = null;
  
  //ERROR
  nombreError: boolean = false;
  clienteIdError: boolean = false;
  errorMessage: string = "";
  errorFinal: boolean = false;
  showImageErrorMessage: boolean = false;
  showImageErrorMessageShow: boolean = false;
  nombreYaExisteError: boolean = false;
  cervezasData: any;

  clientes: Clientes[] = [];
  selectedCliente: number | undefined;

  signin: FormGroup = new FormGroup({
    nombre: new FormControl(''),
  });

  private clientsSubscription: Subscription | undefined;
  private cervezaSubscription: Subscription | undefined;
  private editarProductoSubscription: Subscription | undefined;
  private cervezasSubscription: Subscription | undefined;

  urlBase: string = "";

  constructor(private userService : UserService, private error429: Error429Service, private router: Router,
    private deviceService: DeviceService){
    this.cervezaId = this.getCervezaIdFromCurrentPath(router);
    this.urlBase = environment.urlNonce;
  }

  ngOnInit(): void {
    this.clientsSubscription = this.userService.getClients().subscribe({
      next:resp =>{
        for(let i=0; i<resp.length; i++){
          this.clientes.push({
            value: resp[i].id,
            name: resp[i].razon_social
          });
        }
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete:()=>{}
    });
    this.cervezaSubscription = this.deviceService.getOneBeerType(this.cervezaId).subscribe({
      next: resp =>{
        this.beerData = resp;
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete:()=>{
        this.signin.patchValue({
          nombre: this.beerData.name
        });
        this.selectedCliente = this.beerData.cliente_id;
        this.beerImg = this.beerData.img;
        this.beerDataImgPath = this.urlBase +"/uploads/imgs/"+ this.beerImg;
      }
    });
    this.cervezasSubscription = this.deviceService.getBeerType().subscribe({
      next:resp =>{
        this.cervezasData = resp;
        console.log(this.cervezasData);
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete:()=>{}
    });
  }

  ngOnDestroy(): void {
    if (this.clientsSubscription) {
      this.clientsSubscription.unsubscribe();
    } 
    if (this.cervezaSubscription) {
      this.cervezaSubscription.unsubscribe();
    } 
    if (this.editarProductoSubscription) {
      this.editarProductoSubscription.unsubscribe();
    } 
    if (this.cervezasSubscription) {
      this.cervezasSubscription.unsubscribe();
    } 
  }

  previewImage() {
    this.reader.onload = () => {
      this.imageUrl = this.reader.result;
      /*if (typeof this.reader.result === 'string') {
        this.base64Image = this.reader.result.split(',')[1];
        console.log(this.base64Image);
      }*/
    };
    this.reader.readAsDataURL(this.file as Blob);
  }

  onFileSelected(event: any) {
    //this.file = (event.target as HTMLInputElement).files[0];
    this.file = event.target.files[0];
    if (this.file && this.file !==undefined && (this.file.type === 'image/jpeg' || this.file.type === 'image/png')) {
      this.previewImage();
      this.showImageErrorMessage = false;
      this.formData.append('img', this.file as Blob);
    } else {
      this.imageUrl = null;
      this.showImageErrorMessage = true;
    }
    if(this.file == undefined){
      this.showImageErrorMessage = false;
    }
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  getCervezaIdFromCurrentPath(router: Router): number {
    const urlTree = router.parseUrl(router.url);
    const segments: UrlSegment[] = urlTree.root.children['primary'].segments;
    // Buscamos el segmento que contiene el número
    let deviceId: number | null = null;
    for (const segment of segments) {
      const value = parseInt(segment.path, 10);
      if (!isNaN(value)) {
        deviceId = value;
        break;
      }
    }
    return deviceId || 0;
  }

  get nombreInput() { 
    return this.signin.get('nombre'); 
  }

  clearField(fieldName: string) {
    this.signin.get(fieldName)?.setValue('');
  }

  guardarCliente(){
    //Mostrar el mensaje de error de la imagen solo cuando se le da al botón de guardar
    this.showImageErrorMessageShow = false;
    if(this.showImageErrorMessage){
      this.showImageErrorMessageShow = true;
    }
    //Error razonSocial vacio
    if(this.nombreInput?.value == ""){
      this.nombreError = true;
    } else{
      this.nombreError = false;
    }
    //Error Cliente seleccionado
    if (this.selectedCliente === undefined) {
      this.clienteIdError = true;
    } else {
      this.clienteIdError = false;
    }

    //Si no hay errores el cliente se crea correctamente
    if(this.nombreError == false && this.clienteIdError == false && !this.showImageErrorMessage && !this.nombreYaExisteError){

      const productoData = new FormData();
      productoData.append('_method', "PATCH");
      productoData.append('id', this.cervezaId?.toString() || '');
      productoData.append('name', this.nombreInput?.value || '');
      productoData.append('img', this.file as Blob);
      productoData.append('cliente_id', this.selectedCliente?.toString() || '');

      this.editarProductoSubscription = this.deviceService.editBeerType(productoData).subscribe({
        next: resp => {
          console.log(resp);
        },error: err =>{
          this.errorMessage = err.error.message;
          console.log(this.errorMessage);
          if(this.errorMessage == undefined){
            this.errorMessage = err.error.error;
            console.log(this.errorMessage);
          }
          if (!this.waitAfterSave) {
            this.waitAfterSave = true;
            this.errorFinal = true;
            setTimeout(() => {
              this.errorFinal = false;
              this.waitAfterSave = false;
            },3500)
          }
        }, complete: () =>{
          if(!this.waitAfterSave){
            this.waitAfterSave = true;
            this.cervezaCreada=true;
            setTimeout(() => {
              this.waitAfterSave = false;
              this.cervezaCreada = false;
            }, 3500);
          }
        }
      });
    }
    
    console.log("ID: ",this.cervezaId);
    console.log("Nombre: ", this.nombreInput?.value);
    console.log("Cliente seleccionado: ", this.selectedCliente);
    console.log("Imagen: ", this.file as Blob);
    console.log('---------------------------------------');
  }

}
